//Tracker
import workOrdersTrackerTabRedux from '../../views/trackerTab/redux/slice'
import workOrdersCreateEditWorkOrderRedux from '../../views/trackerTab/modals/createEditWorkOrder/redux/slice'
import workOrdersDriverSelectorRedux from '../../views/trackerTab/modals/driverSelector/redux/slice'
import workOrdersCustomerSelectorRedux from '../../views/trackerTab/modals/customerSelector/redux/slice'
import workOrdersTrackerTabAdvancedFiltersRedux from '../../views/trackerTab/modals/advancedFilters/redux/slice'
import workOrdersMainRedux from '../../views/main/redux/slice'
import workOrdersSettingsWorkOrderRedux from '../../views/trackerTab/modals/createEditWorkOrder/views/settings/redux/slice'
import workOrdersDeleteWorkOrderRedux from '../../views/trackerTab/modals/deleteWorkOrder/redux/slice'
import workOrdersCommentsWorkOrderRedux from '../../views/trackerTab/modals/createEditWorkOrder/views/comments/redux/slice'
import workOrdersHistoryLogsWorkOrderRedux from '../../views/trackerTab/modals/createEditWorkOrder/views/historyLogs/redux/slice'
import workOrdersScheduleRedux from '../../views/schedule/redux/slice'
import workOrdersChangeStatusRedux from '../../views/trackerTab/modals/changeStatus/redux/slice'
import workOrdersScheduleAdvanceFilterRedux from '../../views/schedule/modules/AdvanceFilter/redux/slice'

//WorkOrder
import workOrdersWorkOrderTabRedux from '../../views/workOrderTab/redux/slice'
import workOrdersWorkOrderTabAdvancedFiltersRedux from '../../views/workOrderTab/modals/advancedFilters/redux/slice'

//Customers
import workOrdersCustomerTabRedux from '../../views/customerTab/redux/slice'
import workOrdersCreateEditCustomerRedux from '../../views/customerTab/modals/createEditCustomer/redux/slice'
import workOrdersImportCustomersRedux from '../../views/customerTab/modals/importCustomers/redux/slice'
import workOrdersDeleteCustomerRedux from '../../views/customerTab/modals/deleteCustomer/redux/slice'
import workOrdersCustomerDetailRedux from '../../views/customerDetail/redux/slice'

//Locations
import workOrdersLocationTabRedux from '../../views/locationTab/redux/slice'
import workOrdersCreateEditLocationRedux from '../../views/locationTab/modals/createEditLocation/redux/slice'
import workOrdersDeleteLocationRedux from '../../views/locationTab/modals/deleteLocation/redux/slice'

//Contacts
import workOrdersContactTabRedux from '../../views/contactTab/redux/slice'
import workOrdersCreateEditContactRedux from '../../views/contactTab/modals/createEditContact/redux/slice'
import workOrdersDeleteContactRedux from '../../views/contactTab/modals/deleteContact/redux/slice'

export default {
  workOrdersTrackerTabRedux,
  workOrdersCreateEditWorkOrderRedux,
  workOrdersCustomerTabRedux,
  workOrdersCreateEditCustomerRedux,
  workOrdersDriverSelectorRedux,
  workOrdersCreateEditLocationRedux,
  workOrdersCreateEditContactRedux,
  workOrdersCreateEditLocationRedux,
  workOrdersCustomerSelectorRedux,
  workOrdersImportCustomersRedux,
  workOrdersDeleteCustomerRedux,
  workOrdersCustomerDetailRedux,
  workOrdersLocationTabRedux,
  workOrdersContactTabRedux,
  workOrdersWorkOrderTabRedux,
  workOrdersMainRedux,
  workOrdersWorkOrderTabAdvancedFiltersRedux,
  workOrdersDeleteLocationRedux,
  workOrdersDeleteContactRedux,
  workOrdersTrackerTabAdvancedFiltersRedux,
  workOrdersSettingsWorkOrderRedux,
  workOrdersDeleteWorkOrderRedux,
  workOrdersCommentsWorkOrderRedux,
  workOrdersHistoryLogsWorkOrderRedux,
  workOrdersScheduleRedux,
  workOrdersChangeStatusRedux,
  workOrdersScheduleAdvanceFilterRedux
};